"use client";
import { api } from "@smart-polling/backend/convex/_generated/api";
import { usePaginatedQuery } from "convex/react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function ExplorePage() {
  const polls = usePaginatedQuery(api.polls.getPublicPolls, {}, { initialNumItems: 10 });

  if (polls.results.length === 0) return null;

  return (
    <div className="container mx-auto max-w-3xl px-4 py-6">
      <h1 className="font-semibold text-2xl">Explore Polls</h1>
      <div className="grid gap-4">
        {polls.results.map((p) => (
          <Card key={p._id}>
            <CardHeader>
              <CardTitle>{p.title}</CardTitle>
              {p.description && <CardDescription>{p.description}</CardDescription>}
            </CardHeader>
            <CardContent className="flex gap-3">
              <a href={`/polls/${p._id}`}>
                <Button>Answer</Button>
              </a>
            </CardContent>
          </Card>
        ))}
        {polls.status === "CanLoadMore" && <Button onClick={() => polls.loadMore(10)}>Load more</Button>}
        {!polls.results.length && <div className="text-muted-foreground">No polls yet. Create one!</div>}
      </div>
    </div>
  );
}
